<template>
  <inventoryProductsCategoriesList/>
</template>
<script>
import inventoryProductsCategoriesList from '@/components/modules/inventory/products/categories/list'
export default {
  name: 'inventoryCategories',
  components: {
    inventoryProductsCategoriesList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/inventory/products/categories/list.vue